module.exports = __webpack_public_path__ + "img/hondainsight.5a179341.png";